// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { __read } from "tslib";
/**
 * Returns canonical headers.
 *
 * @param headers Headers from the request.
 * @returns Request headers that will be signed, and their values, separated by newline characters. Header names must
 * use lowercase characters, must appear in alphabetical order, and must be followed by a colon (:). For the values,
 * trim any leading or trailing spaces, convert sequential spaces to a single space, and separate the values
 * for a multi-value header using commas.
 *
 * @internal
 */
export var getCanonicalHeaders = function (headers) {
    return Object.entries(headers)
        .map(function (_a) {
        var _b = __read(_a, 2), key = _b[0], value = _b[1];
        var _c;
        return ({
            key: key.toLowerCase(),
            value: (_c = value === null || value === void 0 ? void 0 : value.trim().replace(/\s+/g, ' ')) !== null && _c !== void 0 ? _c : '',
        });
    })
        .sort(function (a, b) { return (a.key < b.key ? -1 : 1); })
        .map(function (entry) { return entry.key + ":" + entry.value + "\n"; })
        .join('');
};
//# sourceMappingURL=getCanonicalHeaders.js.map